import { useEffect, useRef, useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import axiosInstance from '@/services/api/axios';

export default function RequisiteQrButton({ id }: { id: string }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const request = useRef<AbortController | null>(null);
  useEffect(() => () => { request.current?.abort(); }, []);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);
  const close = () => { request.current?.abort(); setOpen(false); setUrl(null); };
  const view = async () => {
    request.current?.abort();
    const controller = new AbortController(); request.current = controller;
    setOpen(true); setError(false);
    try {
      const { data } = await axiosInstance.get<Blob>(`/requisites/${id}/qr`, { responseType: 'blob', signal: controller.signal });
      if (!controller.signal.aborted) setUrl(URL.createObjectURL(data));
    } catch { if (!controller.signal.aborted) setError(true); }
  };
  return <>
    <Button onClick={() => void view()} size="small">QR</Button>
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>Банковский QR</DialogTitle>
      <DialogContent>
        {error ? <Alert severity="error">Не удалось загрузить QR. Закройте окно и повторите попытку.</Alert>
          : url ? <img src={url} alt="Банковский QR реквизита" style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block', margin: 'auto' }} />
            : <CircularProgress />}
      </DialogContent>
      <DialogActions><Button onClick={close}>Закрыть</Button></DialogActions>
    </Dialog>
  </>;
}
